module.exports = __webpack_public_path__ + "img/ipyxiaochengxu.c1939d10.png";